import {
  useAction,
  useList,
  useDetail,
  useCreate,
  usePartialUpdate,
  useDelete,
  useData,
  useListInfinite,
} from "@inmagik/react-crud"
import { useQueryClient } from "@tanstack/react-query"
import { Fondo, HistoricalInfo } from "../types"
import { API_URL } from "../constants"

export function useFondiList(params: Record<string, string | number | string[] | number[]> = {}) {
  return useList<Fondo>(`${API_URL}/fondi`, {
    query: params,
  })
}

export function useFondo(id: number | undefined | string) {
  return useDetail<Fondo>(`${API_URL}/fondi`, id?.toString())
}

export function useFondoCreate() {
  return useCreate<Fondo>(`${API_URL}/fondi`)
}

export function useFondoUpdate() {
  return usePartialUpdate<Fondo>(`${API_URL}/fondi`)
}

export function useFondoDelete() {
  return useDelete<Fondo>(`${API_URL}/fondi`)
}

export function useFondoHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/fondi/${id}/history`)
}

export function useFondoSetAllegati(id: number | string) {
  return useAction(`${API_URL}/fondi/${id}/set-allegati`, {
    method: "POST",
    encode: "formdata",
  })
}

export function useCalcolasegnaturaFondo(produttore_id?: number, fondo_id?: number, prefisso?: string) {
  return useData<string>(`${API_URL}/fondi/calcola_segnatura`, {
    query: { produttore: produttore_id, fondo: fondo_id, prefisso: prefisso },
    reactQuery: { enabled:  (prefisso || "").length === 2 }
  })
}

export function useDownloadFondi(params: Record<string, string | number | string[] | number[]> = {}) {
  return useAction<Blob, void>(`${API_URL}/fondi/download`, {
    method: "GET",
    query: params,
    responseType: "blob",
  })
}

export function useDownloadFondo(id: number | string) {
  return useAction<Blob, void>(`${API_URL}/fondi/${id}/download-detail`, {
    method: "GET",
    responseType: "blob",
  })
}

type FondoEliminaConSupportiResponse = {
  supporti_eliminati: number
  documenti_eliminati: number
}

export function useFondoEliminaConSupporti(id: number | string | undefined) {
  const client = useQueryClient()
  return useAction<FondoEliminaConSupportiResponse, { segnatura: string }>(
    `${API_URL}/fondi/${id}/elimina-con-supporti`,
    {
      method: "POST",
      reactQuery: {
        onSuccess: () => {
          client.invalidateQueries({ queryKey: [`${API_URL}/fondi`] })
        },
      },
    }
  )
}
